<template>
  <v-container fluid py-0 px-0>
    <u-i-toolbar-admin :title="titlePage" icon="fas fa-eye"/>
    <v-layout py-4>
      <v-flex xs12 sm12 md7 lg5 py-0 px-2>
        <div class="filter-label-text">Label color</div>
        <v-select
          v-model="labelColor"
          item-text="label"
          item-value="value"
          :items="labelColors"
          id="labelColor"
          name="labelColor"
          class="labelColor"
          box
          solo
          full-width
        >
          <template v-slot:append-outer>
            <v-layout justify-center fill-height>
              <v-icon class="fa-solid center-icon" :color="color">
                fa-palette
              </v-icon>
              <v-btn @click="setColor" color="warning" round>Save</v-btn>
            </v-layout>
          </template>
        </v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap py-2>
      <v-flex>
        <u-i-table-admin
          :headers="headers"
          :items="groupOrders"
          can-be-delete-name-field="can_be_deleted_from_group"
          with-actions
          delete-confirmation
          @delete-action="deleteItem"
          @view-action="viewOrder"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import UITableAdmin from '@/components/UI/TableAdmin';
import CombinedService from '@/services/Admin/CombinedOrders';
import {actionsOrder} from '@/mixins/actionsOrder';

export default {
  name: 'AdminViewGroup',
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  props: {
    id: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    UITableAdmin,
    UIToolbarAdmin,
  },
  mixins: [actionsOrder],
  data() {
    return {
      labelColor: null,
      labelColors: [
        {
          label: '-',
          value: null,
          color: '#fafafa'
        },
        {
          label: 'Green',
          value: 'green',
          color: 'green'
        },
        {
          label: 'Red',
          value: 'red',
          color: 'red'
        },
      ],

      groupOrders: [],
      headers: [
        {text: 'Order ID', value: 'id', prefix: '#', sortable: true, class: 'th-blue', classTagTd: ''},
        {
          text: 'MailBox',
          value: 'mailbox',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Tracking number',
          value: 'tracking_number_external',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Consignee',
          value: 'recipient_name',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Address',
          value: 'address',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Actions', value: '', prefix: '', sortable: false, class: 'th-blue text-xs-center px-1', actions: [
            {action: 'view', path: 'admin/orders/view', hide: false},
            {action: 'delete', path: '', hide: false},
          ]
        }
      ],

      messages: {},
    }
  },
  created() {
    this.getGroupOrders();
  },
  computed: {
    titlePage() {
      return 'Group #' + this.id;
    },
    color() {
      return this.labelColors.find((item => item.value === this.labelColor)).color || '#fafafa';
    }
  },
  methods: {
    setColor() {
      CombinedService.setLabelColors(this.id, this.labelColor)
        .then(resp => {
          if (resp.status === this.$response.Ok) {
            this.$store.commit('setSuccess', resp.data.message);
          }
        })
        .catch(err => {
          this.$store.commit('setError', err.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    getGroupOrders() {
      CombinedService.getGroupOrders(this.id)
        .then(resp => {
          if (resp.status === this.$response.Ok) {
            this.groupOrders = resp.data.data.orders;
            this.labelColor = resp.data.data.label_color;
          }
        })
        .catch(err => {
          if (err.response.status === this.$response.NotFound) {
            this.$router.push({name: 'AdminCombinedOrders'});
          }
          this.$store.commit('setError', err.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    deleteItem(item) {
      this.sendDeleteItem(item.id);
    },
    sendDeleteItem(id) {
      this.$store.commit('setLoading', true)
      CombinedService.deleteOrderFromGroup(id)
        .then(resp => {
          if (resp.status === this.$response.Ok) {
            this.getGroupOrders();
          }
        })
        .catch(err => {
          this.$store.commit('setError', err.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    }
  }
}
</script>

<style lang="stylus">

.labelColor .v-input__append-outer
  margin-top 0 !important

</style>